import SystemInfoLayout from './SystemInfoLayout';

export default SystemInfoLayout;
